export default function noop(): void {
  // Nothing to see here
}
